import React, { useContext } from 'react'

import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from '@clientbase/clientbase-library'
import { Box } from '@mui/material'
import historicChangesMapper, {
  Historic as HistoricType
} from 'models/Historic/HistoricChanges'

import { Table } from 'components/Table'

import { theme } from 'styles/theme'

import { ModalChargeDetailContext } from '../../context'
import { cardTittle } from '../../ModalChargeDetail.utils'

const Historic: React.FC = () => {
  const { invoice } = useContext(ModalChargeDetailContext)
  return (
    <Accordion
      sx={{
        border: '1px solid #E8EBE8',
        borderLeft: '3px solid',
        borderLeftColor: 'primary.main',
        borderRadius: '8px !important',
        backgroundColor: '#FAFBFA',
        boxShadow: 'none',
        '&:before': { display: 'none' },
        '&.Mui-expanded': {
          margin: 0,
          backgroundColor: '#fff'
        }
      }}
    >
      <AccordionSummary
        aria-controls="changesHistory-content"
        id="historyChanges"
      >
        {cardTittle('Histórico', 'article', `${theme.palette.primary.main}`)}
      </AccordionSummary>
      <AccordionDetails>
        <Box
          sx={{
            width: '100%',
            [theme.breakpoints.down(450)]: {
              maxWidth: '40vh'
            }
          }}
        >
          <Table
            mobileCards
            header={[
              { id: 'action', label: 'Ação' },
              { id: 'description', label: 'Descrição' },
              { id: 'date', label: 'Data' },
              { id: 'user', label: 'Usuário' }
            ]}
            rows={historicChangesMapper(invoice?.historic as HistoricType)}
            select={{ useSelect: false }}
            hiddePagination
          />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export default Historic
